/* Tersa clone — quantity buy box, gallery, sticky bar, cart permalink + tier discounts */
(function(){
  if(window.__tersaCloneInit) return; window.__tersaCloneInit = true;
  function init(){
    var root = document.querySelector('[data-tersa-app]');
    if(!root) return;
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-tersa-opt]'));
    var atcTotals = document.querySelectorAll('[data-tersa-atc-total]');
    var barTotal = document.querySelector('[data-tersa-bar-total]');
    var barMode = document.querySelector('[data-tersa-bar-mode]');
    var ebook = root.querySelector('[data-tersa-ebook]');
    var state = { variantId:null, qty:1, code:'', total:'' };

    function select(opt){
      opts.forEach(function(o){
        var on = o===opt;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-checked', on?'true':'false');
      });
      state.variantId = opt.getAttribute('data-variant-id');
      state.qty = parseInt(opt.getAttribute('data-qty')||'1',10);
      state.code = opt.getAttribute('data-code')||'';
      state.total = opt.getAttribute('data-total');
      var showEbook = opt.getAttribute('data-ebook')==='1';
      atcTotals.forEach(function(el){ el.textContent = state.total; });
      if(barTotal) barTotal.textContent = state.total;
      if(barMode) barMode.textContent = opt.getAttribute('data-mode-label')||'';
      if(ebook) ebook.classList.toggle('is-on', showEbook);
    }
    opts.forEach(function(o){
      o.addEventListener('click', function(){ select(o); });
      o.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); select(o); } });
    });
    var def = root.querySelector('[data-tersa-opt][data-default]') || opts[0];
    if(def) select(def);

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tersa-thumb]'));
    var mainImg = root.querySelector('[data-tersa-main]');
    var mainLabel = root.querySelector('[data-tersa-main-label]');
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        thumbs.forEach(function(x){ x.classList.toggle('is-active', x===t); });
        var src = t.getAttribute('data-img');
        if(mainImg){
          if(src){ mainImg.style.backgroundImage = "url('"+src+"')"; mainImg.style.backgroundSize='cover'; mainImg.style.backgroundPosition='center'; }
          if(mainLabel) mainLabel.textContent = t.getAttribute('data-label')||'';
        }
      });
    });

    function checkout(btn){
      if(!state.variantId) return;
      var labelEl = btn.querySelector('[data-tersa-atc-label]');
      if(labelEl) labelEl.textContent = 'Agregando…';
      var go = function(){
        var url = '/cart/' + state.variantId + ':' + state.qty;
        if(state.code) url += '?discount=' + encodeURIComponent(state.code);
        window.location.href = url;
      };
      fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} }).then(go).catch(go);
    }
    document.querySelectorAll('[data-tersa-atc]').forEach(function(btn){
      btn.addEventListener('click', function(e){ e.preventDefault(); checkout(btn); });
    });

    /* Sticky bar: lift to <body> so position:fixed pins to the viewport, and
       reveal it via IntersectionObserver (works regardless of scroll container). */
    var sticky = document.querySelector('[data-tersa-sticky]');
    if(sticky){
      var heroAtc = root.querySelector('[data-tersa-atc]');
      if(sticky.parentNode !== document.body){ document.body.appendChild(sticky); }
      var show = function(v){ sticky.classList.toggle('is-visible', v); };
      if(heroAtc && 'IntersectionObserver' in window){
        new IntersectionObserver(function(entries){ show(!entries[0].isIntersecting); }, { threshold: 0 }).observe(heroAtc);
      } else {
        var onScroll = function(){ show((window.scrollY || document.documentElement.scrollTop || 0) > 640); };
        window.addEventListener('scroll', onScroll, { passive:true });
        document.addEventListener('scroll', onScroll, { passive:true, capture:true });
        onScroll();
      }
    }
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
